/*
  🔧 Theme Sauce — buzzwoo E-Com Kitchen
  Ideenverlag · PDP-Countdown — Info-Symbol (bw-iv-cd-info)

  Custom Element <bw-cd-info>: das „i"-Symbol oben rechts in der
  Countdown-Karte schaltet ein kleines Popup mit dem Block-Richtext.

  - Antippen/Klick: öffnet bzw. schließt (aria-expanded + .is-open)
  - Klick außerhalb oder Esc: schließt (Esc gibt den Fokus ans Symbol zurück)
  - Hover auf Geräten mit echtem Hover regelt allein das CSS
    (bw-iv-pdp-modern.css, @media (hover: hover)) — hier kein Hover-JS,
    nur die Richtungsmessung (s.u.) läuft auch bei mouseenter.
  - Richtung (10/2026): Das Popup öffnet nach unten. Liegt seine Unterkante
    dann außerhalb des nächsten clippenden Vorfahren (die Buybox-Section hat
    overflow:hidden für den Gradient-Strip), bekommt <bw-cd-info> die Klasse
    .is-up und das Popup klappt über das Symbol — sonst fehlt die letzte
    Zeile, sobald der Countdown-Block ganz unten in der Buybox steht.

  Idempotent über connected/disconnectedCallback, weil der Theme-Editor
  Blöcke beim Bearbeiten neu einsetzt.
*/
if (!customElements.get('bw-cd-info')) {
  customElements.define('bw-cd-info', class BwCdInfo extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.bw-iv-cd-info__btn');
      if (!this.button) return;

      this.pop = this.querySelector('.bw-iv-cd-info__pop');
      this.onToggle = () => this.setOpen(this.button.getAttribute('aria-expanded') !== 'true');
      this.onEnter = () => this.placePopup();
      this.onResize = () => { if (this.button.getAttribute('aria-expanded') === 'true') this.placePopup(); };
      this.onOutside = (event) => { if (!this.contains(event.target)) this.setOpen(false); };
      this.onKey = (event) => {
        if (event.key !== 'Escape' || this.button.getAttribute('aria-expanded') !== 'true') return;
        this.setOpen(false);
        this.button.focus();
      };

      this.button.addEventListener('click', this.onToggle);
      this.addEventListener('mouseenter', this.onEnter);
      this.button.addEventListener('focus', this.onEnter);
      window.addEventListener('resize', this.onResize);
      document.addEventListener('pointerdown', this.onOutside);
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this.onToggle);
      this.removeEventListener('mouseenter', this.onEnter);
      this.button.removeEventListener('focus', this.onEnter);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('pointerdown', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }

    setOpen(open) {
      if (open) this.placePopup();
      this.button.setAttribute('aria-expanded', String(open));
      this.classList.toggle('is-open', open);
    }

    /* Nächsten Vorfahren mit overflow != visible finden (clippt absolut
       positionierte Kinder); ohne Treffer gilt der Viewport. */
    clipRect() {
      for (let el = this.parentElement; el && el !== document.body; el = el.parentElement) {
        const cs = getComputedStyle(el);
        if (cs.overflowY !== 'visible' || cs.overflowX !== 'visible') return el.getBoundingClientRect();
      }
      return { top: 0, bottom: window.innerHeight };
    }

    placePopup() {
      if (!this.pop) return;
      // Erst in Standardlage messen (das Popup ist auch geschlossen im Layout, nur visibility:hidden)
      this.classList.remove('is-up');
      const clip = this.clipRect();
      const pop = this.pop.getBoundingClientRect();
      const btn = this.button.getBoundingClientRect();
      const overflowsBottom = pop.bottom > clip.bottom;
      const fitsAbove = btn.top - pop.height >= clip.top;
      this.classList.toggle('is-up', overflowsBottom && fitsAbove);
    }
  });
}
